export default __webpack_public_path__ + "static/media/bankVerificationhelpMobileHighlight.f98e3407.png";